
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/1",
      function () {
        return require("private-next-pages/onboarding/1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding/1"])
      });
    }
  